// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6f57eb85","455":"604088ef","977":"b46a3797"}[chunkId] + ".chunk.js";
};